var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAdd = function SvgIcAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_add_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    fill: "#6EC7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.806 7.166H9.333V5.693c0-.734-.6-1.334-1.334-1.334-.733 0-1.333.6-1.333 1.334v1.473H5.193c-.734 0-1.334.6-1.334 1.333 0 .734.6 1.334 1.334 1.334h1.473v1.473c0 .733.6 1.333 1.333 1.333.734 0 1.334-.6 1.334-1.333V9.833h1.473c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_add_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIcAdd;